import { MutationTree } from 'vuex';
import { LendingRecordState, LendingRecord } from './types';
import * as types from './mutation-types';

// エラーをクリアする
const resetErrors = (state: LendingRecordState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;
};

export const mutations: MutationTree<LendingRecordState> = {
    // 一覧系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; lending_records: Array<LendingRecord> }) {
        state.lendingRecordCount = payload.count;
        state.lendingRecords = payload.lending_records;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },
};
